import { render } from "./Hero.vue?vue&type=template&id=2dd53d42&ts=true"
import script from "./Hero.vue?vue&type=script&lang=ts"
export * from "./Hero.vue?vue&type=script&lang=ts"

import "./Hero.vue?vue&type=style&index=0&id=2dd53d42&lang=scss"

import exportComponent from "C:\\Users\\nahue\\OneDrive\\Escritorio\\Proyectos\\SWMOTORES\\source\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__